import { useEffect, useState } from 'react';

export const useUserPermisos = () => {
  const [permisos, setPermisos] = useState(null)
  const [usuario, setUsuario] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let isMounted = true
    setLoading(true)
    fetch('/info_user', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({})
    })
      .then(res => res.json())
      .then(res => {
        if (!isMounted) return
        if (res && res.estado === 1) {
          const infoUsuario = res.resultado || {}
          const tipoUsuario = Number(infoUsuario.tipo_usuario)
          const usuarioNormalizado = {
            ...infoUsuario,
            tipo_usuario: Number.isFinite(tipoUsuario) ? tipoUsuario : undefined
          }
          setUsuario(usuarioNormalizado)
          setPermisos(usuarioNormalizado.permisos || {})
        } else {
          setUsuario(null)
          setPermisos({})
        }
      })
      .catch(() => {
        if (isMounted) {
          setUsuario(null)
          setPermisos({})
        }
      })
      .finally(() => {
        if (isMounted) setLoading(false)
      })
    return () => { isMounted = false }
  }, [])

  return { permisos, usuario, loading }
}
